<app-header></app-header>
<div class="body-container clearfix">
    <div class="embed-responsive embed-responsive-docusign">
        <iframe *ngIf="type == 'dsign'" class="embed-responsive-item" [src]="docuSignUrl" allowfullscreen></iframe>
        <iframe *ngIf="type == 'pdf'" id="contractIframe" class="docusign-iframe pdf" width="100%" frameborder="0" allowfullscreen></iframe>
        <button *ngIf="type == 'pdf'" type="button" class="btn btn-primary btn-lg col-12 pdf-back-to-home-button" routerLink="/home">Back to Home</button>
        <span *ngIf="type == 'pdf'">{{renderPdf()}}</span>
    </div>
</div>
<app-footer></app-footer>